<template>
  <div>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Link Copied') }}!</v-snackbar
    >
    <template v-if="!['scgdistribution'].includes(selectedBot.theme)">
      <ConnectLineTraditional />
      <v-divider />
      <v-container>
        <SocialConnect></SocialConnect>
      </v-container>

      <ConnectAccount />

      <v-container>
        <v-layout wrap>
          <v-flex xs6>Bot id</v-flex>
          <v-flex xs6
            >{{ selectedBot.pageid }}
            <v-btn
              v-clipboard:copy="selectedBot.pageid"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
              small
              fab
              flat
              color="primary"
            >
              <v-icon>content_copy</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SocialConnect from '@/components/view/billing/SocialConnect.vue'
import ConnectAccount from '@/components/view/customAudience/ConnectAccount.vue'
import ConnectLineTraditional from '@/components/view/billing/ConnectLineTraditional.vue'
export default {
  components: {
    SocialConnect,
    ConnectAccount,
    ConnectLineTraditional
  },
  data() {
    return {
      showCopy: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
    onCopyError: function () {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/SocialConnectManagement.vue